import React from 'react';
import ProjectRow from './ProjectRow';
import { MORE_PROJECTS as PROJECTS } from '../Home/data';

const MoreProjects = () => (
  <section id="moreProjects">
    <div className="moreProjects-header">
      <h3>More projects</h3>
      <div className="line" />
    </div>
    {PROJECTS.map(project => (
      <ProjectRow
        key={project.name}
        name={project.name}
        type={project.type}
        href={project.href}
      />
    ))}
  </section>
);

export default MoreProjects;



// WEBPACK FOOTER //
// ./src/Modules/MoreProjects/MoreProjects.js